module.exports = __webpack_public_path__ + "img/jj4.ee27daf6.png";